var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.score)?_c('td',{staticClass:"score",class:_vm.textcolor},[_vm._v("\n  "+_vm._s(_vm.formatScore(_vm.score))+"\n")]):_c('td',{staticClass:"score"})
}
var staticRenderFns = []

export { render, staticRenderFns }